import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Form, Input, Row, Switch } from "@ster/ster-toolkit";
import { Col, FormInstance, Space } from "antd";
import { useState } from "react";

import { AdvertiserRegistration } from "../../store/coreApi";
import IndustryCodesInput from "./IndustryCodesInput";

const AdvertiserRegistrationEditFormSection = ({
  form,
}: {
  form: FormInstance<AdvertiserRegistration>;
}) => {
  const i18n = useLingui();
  const [isPayingParty, setIsPayingParty] = useState<boolean>(true);

  return (
    <Form<AdvertiserRegistration> form={form}>
      <Form.Item<AdvertiserRegistration>
        label={i18n._(t`Accountnaam`)}
        name="accountName"
        rules={[
          {
            required: true,
            message: i18n._(t`Vul een accountnaam in`),
          },
        ]}
      >
        <Input
          placeholder={`${i18n._(t`Naam van het account`)}...`}
          maxLength={255}
        />
      </Form.Item>
      <Form.Item<AdvertiserRegistration>
        label={i18n._(t`KvK-nummer`)}
        name="kvkNumber"
        rules={[
          {
            required: true,
            message: i18n._(t`Vul een KvK-nummer in`),
          },
        ]}
      >
        <Input placeholder={`${i18n._(t`KvK-nummer`)}...`} />
      </Form.Item>
      <Form.Item<AdvertiserRegistration>
        label={i18n._(t`Statutaire naam`)}
        name="kvkStatutoryName"
        rules={[
          {
            required: true,
            message: i18n._(t`Vul een statutaire naam in`),
          },
        ]}
      >
        <Input
          placeholder={`${i18n._(t`Statutaire naam`)}...`}
          maxLength={255}
        />
      </Form.Item>
      <Form.Item<AdvertiserRegistration>
        label={i18n._(t`Product`)}
        name="product"
        rules={[
          {
            required: true,
            message: i18n._(t`Vul een product in`),
          },
        ]}
      >
        <Input placeholder={`${i18n._(t`Product`)}...`} maxLength={255} />
      </Form.Item>

      <Form.Item<AdvertiserRegistration>
        name="industryCodes"
        label={i18n._(t`Branchecodering`)}
        rules={[
          { required: true, message: i18n._(t`Vul een branchecodering in`) },
        ]}
      >
        <IndustryCodesInput placeholder={`${i18n._(t`Branchecodering`)}...`} />
      </Form.Item>

      <Form.Item<AdvertiserRegistration>
        label={i18n._(t`Contactpersoon`)}
        name="contactPerson"
      >
        <Input
          placeholder={`${i18n._(t`Contactpersoon`)}...`}
          maxLength={255}
        />
      </Form.Item>

      <Form.Item label={i18n._(t`Adres`)}>
        <Space direction="vertical" style={{ width: "100%" }}>
          {/* Adres */}
          <Row gutter={[8, 0]}>
            <Col flex="auto">
              {/* Straatnaam */}
              <Form.Item
                name={["address", "street"]}
                rules={[
                  { required: true, message: i18n._(t`Vul een straatnaam in`) },
                ]}
                noStyle
              >
                <Input
                  placeholder={`${i18n._(t`Straatnaam`)}...`}
                  maxLength={255}
                />
              </Form.Item>
            </Col>
            <Col flex="100px">
              {/* Huisnummer */}
              <Form.Item
                name={["address", "houseNumber"]}
                rules={[
                  { required: true, message: i18n._(t`Vul een huisnummer in`) },
                ]}
                noStyle
              >
                <Input placeholder={`${i18n._(t`Nr.`)}...`} maxLength={20} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col flex="140px">
              {/* Postal code */}
              <Form.Item
                name={["address", "postalCode"]}
                rules={[
                  { required: true, message: i18n._(t`Vul een postcode in`) },
                ]}
                noStyle
              >
                <Input
                  placeholder={`${i18n._(t`Postcode`)}...`}
                  maxLength={7}
                />
              </Form.Item>
            </Col>
            <Col flex="auto">
              {/* City */}
              <Form.Item
                name={["address", "city"]}
                rules={[
                  { required: true, message: i18n._(t`Vul een plaatsnaam in`) },
                ]}
                noStyle
              >
                <Input
                  placeholder={`${i18n._(t`Plaatsnaam`)}...`}
                  maxLength={255}
                />
              </Form.Item>
            </Col>
          </Row>
        </Space>
      </Form.Item>

      <Form.Item label={i18n._(t`Adverteerder is betalende partij`)}>
        <Switch
          checkedChildren={i18n._(t`Ja`)}
          unCheckedChildren={i18n._(t`Nee`)}
          value={isPayingParty}
          onChange={setIsPayingParty}
        />
      </Form.Item>

      {isPayingParty === false && (
        <Form.Item<AdvertiserRegistration>
          label={i18n._(t`Betalende partij`)}
          name="payingParty"
        >
          <Input
            placeholder={`${i18n._(t`Betalende partij`)}...`}
            maxLength={255}
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default AdvertiserRegistrationEditFormSection;
